<template>
    <div class="flex min-h-screen">
        <div class="col-12 md:col-5">
            <div class="header header__logo">
                <a href="/ru">
                    <img src="/i/logos/keysso-black.webp" />
                </a>
                <div class="block md:hidden header__logout">
                    <a href="/ru/logout">
                        <i class="pi pi-sign-in"></i>
                        {{ $t('lang.pages.qualification.logout') }}
                    </a>
                </div>
            </div>
            <div class="qualification_page__questions">
                <Stepper @step-change="stepChange" :linear="true" :activeStep="model.step - 1">
                    <StepperPanel :pt="{
                        separator: {class: 'm-0'}
                    }">
                        <template #content="{ nextCallback }">
                            <h3>{{ $t('lang.pages.qualification.tool.title') }}</h3>
                            <p>{{ $t('lang.pages.qualification.tool.desc') }}</p>
                            <div class="formgroup">
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.tool" :value="Tools.COMPETITORS" inputId="tool_concurents" />
                                    <label for="tool_concurents">{{ $t('lang.pages.qualification.tool.concurents.label') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.tool" :value="Tools.AI" inputId="tool_ai" />
                                    <label for="tool_ai">{{ $t('lang.pages.qualification.tool.ai.label') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.tool" :value="Tools.SEO" inputId="tool_seo" />
                                    <label for="tool_seo">{{ $t('lang.pages.qualification.tool.seo.label') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.tool" :value="Tools.SEMANTIC" inputId="tool_semantic" />
                                    <label for="tool_semantic">{{ $t('lang.pages.qualification.tool.semantic.label') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.tool" :value="Tools.ADS" inputId="tool_ads" />
                                    <label for="tool_ads">{{ $t('lang.pages.qualification.tool.ads.label') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.tool" :value="Tools.LINKS" inputId="tool_links" />
                                    <label for="tool_links">{{ $t('lang.pages.qualification.tool.links.label') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.tool" :value="Tools.OTHER" inputId="tool_other" />
                                    <label for="tool_other">{{ $t('lang.pages.qualification.tool.other.label') }}</label>
                                </div>
                                <div v-if="model.tool === Tools.OTHER" class="field flex md:hidden">
                                    <TemplatesLabelCounts text="" :count="getCountOtherTool" :limit="maxOtherInputsLength" />
                                    <Textarea
                                        :placeholder="$t('lang.pages.qualification.tool.other.mobile_input_placeholder')"
                                        v-model="model.otherTool"
                                        rows="3"
                                    />
                                </div>
                            </div>
                            <div class="flex pt-4">
                                <Button :label="$t('lang.pages.qualification.next_button')" icon="pi pi-check" @click="nextCallback" :disabled="isDisabledToolsNextStep" />
                            </div>
                        </template>
                    </StepperPanel>
                    <StepperPanel :pt="{
                        separator: {class: 'm-0'}
                    }">
                        <template #content="{ prevCallback, nextCallback }">
                            <h3 class="mb-5">{{ $t('lang.pages.qualification.job.title') }}</h3>
                            <div class="formgroup">
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.job" :value="Jobs.COMPANY" inputId="job_company" />
                                    <label for="job_company">{{ $t('lang.pages.qualification.job.company') }}</label>
                                </div>
                                <template v-if="model.job === Jobs.COMPANY">
                                    <div class="field mb-0">
                                        <AdaptersDropdown
                                            v-model="model.jobPosition"
                                            :options="jobPositions"
                                            option-label="caption"
                                            option-value="id"
                                            class="w-full"
                                            :placeholder="$t('lang.pages.qualification.job.company_position.placeholder')"
                                        />
                                    </div>
                                    <div class="field">
                                        <InputText
                                            v-model="model.jobCompanySite"
                                            :placeholder="$t('lang.pages.qualification.job.company_site_placeholder')"
                                            :maxlength="maxOtherInputsLength"
                                        />
                                    </div>
                                </template>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.job" :value="Jobs.FREELANCE" inputId="job_freelance" />
                                    <label for="job_freelance">{{ $t('lang.pages.qualification.job.freelance') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.job" :value="Jobs.STUDENT" inputId="job_student" />
                                    <label for="job_student">{{ $t('lang.pages.qualification.job.student') }}</label>
                                </div>
                                <div class="field-radiobutton">
                                    <RadioButton v-model="model.job" :value="Jobs.OTHER" inputId="job_other" />
                                    <label for="job_other">{{ $t('lang.pages.qualification.job.other') }}</label>
                                </div>
                                <div v-if="model.job === Jobs.OTHER" class="field">
                                    <TemplatesLabelCounts text="" :count="getCountOtherJob" :limit="maxOtherInputsLength" />
                                    <Textarea
                                        :placeholder="$t('lang.pages.qualification.job.other_input_placeholder')"
                                        v-model="model.otherJob"
                                        rows="3"
                                    />
                                </div>
                            </div>
                            <div class="flex pt-4 gap-2">
                                <Button
                                    severity="secondary"
                                    icon="pi pi-angle-left"
                                    outlined
                                    @click="prevCallback"
                                    class="qualification_page__secondary_button"
                                />
                                <Button
                                    :label="$t('lang.pages.qualification.next_button')"
                                    icon="pi pi-check"
                                    @click="onFinish(nextCallback)"
                                    :disabled="isDisabledJobNextStep"
                                />
                            </div>
                        </template>
                    </StepperPanel>
                    <StepperPanel :pt="{
                        separator: {class: 'm-0'}
                    }">
                        <template #content>
                            <div class="qualification_page__finish_header">
                                <h3>{{ $t('lang.pages.qualification.finish.title') }}</h3>
                                <template v-if="model.job === Jobs.COMPANY">
                                    <p v-html="$t('lang.pages.qualification.finish.desc_company')"></p>
                                </template>
                                <template v-else>
                                    <p v-html="$t('lang.pages.qualification.finish.desc')"></p>
                                </template>
                                <div class="flex flex-wrap gap-2">
                                    <Button
                                        v-if="qualificationRedirectUrl"
                                        type="button"
                                        severity="secondary"
                                        icon="pi pi-arrow-right"
                                        :label="$t('lang.pages.qualification.finish.button_redirect')"
                                        size="small"
                                        :pt="{
                                            label: {class: 'font-medium white-space-nowrap'}
                                        }"
                                        @click="onClickQualificationRedirect"
                                    />
                                    <Button
                                        :label="$t('lang.pages.qualification.finish.button_start')"
                                        icon="pi pi-arrow-right"
                                        size="small"
                                        :pt="{
                                            label: {class: 'font-medium white-space-nowrap'}
                                        }"
                                        @click="onClickStart"
                                    />
                                </div>
                            </div>
                            <span class="inline-block mb-3 text-sm" style="color: #6C757D">{{ $t('lang.pages.qualification.finish.label_help') }}</span>
                            <div class="flex flex-wrap gap-2">
                                <template v-if="model.job === Jobs.COMPANY">
                                    <Button
                                        severity="secondary"
                                        :label="$t('lang.pages.qualification.finish.button_demo')"
                                        size="small"
                                        :pt="{
                                            label: {class: 'font-medium white-space-nowrap'}
                                        }"
                                        @click="onOpenDemo"
                                    />
                                </template>
                                <Button
                                    :label="$t('lang.pages.qualification.finish.button_help')"
                                    severity="secondary"
                                    outlined
                                    size="small"
                                    class="qualification_page__secondary_button"
                                    @click="onClickHelp"
                                >
                                    <template #icon>
                                        <img src="/i/icons/help-secondary.svg" class="p-button-icon-left" style="margin-right: 6px;" />
                                    </template>
                                </Button>
                                <Button
                                    :label="$t('lang.pages.qualification.finish.button_faq')"
                                    severity="secondary"
                                    outlined
                                    size="small"
                                    class="qualification_page__secondary_button"
                                    @click="onClickFAQ"
                                >
                                    <template #icon>
                                        <img src="/i/icons/info-secondary.svg" class="p-button-icon-left" style="width: 16px; margin-left: 4px;" />
                                    </template>
                                </Button>
                                <Button
                                    :label="$t('lang.pages.qualification.finish.button_video')"
                                    severity="secondary"
                                    outlined
                                    size="small"
                                    class="qualification_page__secondary_button"
                                    @click="onClickRutube"
                                >
                                    <template #icon>
                                        <img src="/i/icons/rutube-secondary.svg" class="p-button-icon-left" style="width: 20px; padding: 1px 0;" />
                                    </template>
                                </Button>
                                <Button
                                    :label="$t('lang.pages.qualification.finish.button_tg')"
                                    severity="secondary"
                                    outlined
                                    size="small"
                                    class="qualification_page__secondary_button"
                                    @click="onClickTelegram"
                                >
                                    <template #icon>
                                        <img src="/i/icons/tg-secondary.svg" class="p-button-icon-left" style="width: 20px; padding: 1px 0;" />
                                    </template>
                                </Button>
                            </div>
                        </template>
                    </StepperPanel>
                </Stepper>
            </div>
        </div>
        <div class="col-7 hidden md:block qualification_page__content relative">
            <div class="qualification_page__logout">
                <a href="/ru/logout">
                    <i class="pi pi-sign-in"></i>
                    {{ $t('lang.pages.qualification.logout') }}
                </a>
            </div>
            <div v-if="model.step === 1">
                <StepToolsContent :tool="model.tool" v-model:other="model.otherTool" />
            </div>
            <div v-else-if="model.step === 3">
                <StepFinallyReviews :reviews="reviews" />
            </div>
            <div v-else>
                <img class="qualification_page__content_main_img" src="/i/pages/qualification/main.webp" />
            </div>
        </div>
    </div>
</template>

<script>
import Stepper from "primevue/stepper";
import StepperPanel from "primevue/stepperpanel";
import Button from "primevue/button";
import RadioButton from "primevue/radiobutton";
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import TemplatesLabelCounts from "keysso/templates/LabelCounts.vue";
import { nextTick } from "vue";
import BrowserStorage from "keysso/mixins/BrowserStorage";
import UserApi from "keysso/api/UserApi";
import Alerts from "keysso/mixins/Alerts";
import Redirect from "keysso/mixins/Redirect";
import {Listeners} from "keysso/constants/listeners";
import {StorageKeys} from "keysso/constants/storageKeys";
import AdaptersDropdown from "keysso/component/adapters/Dropdown.vue";
import {QualificationsHelper} from "./helpers/QualificationsHelper";
import StepToolsContent from "./components/StepToolsContent.vue";
import {Constants} from "./constants/constants";
import {Tools} from "./constants/Tools";
import {Jobs} from "./constants/Jobs";
import StepFinallyReviews from "./components/StepFinallyReviews.vue";

export default {
    name: "QualificationPage",
    mixins: [BrowserStorage, Alerts, Redirect],
    props: {
        reviews: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            model: {
                step: 1,
                tool: 0,
                otherTool: '',
                job: null,
                jobPosition: null,
                jobCompanySite: '',
                otherJob: ''
            },
            jobPositions: QualificationsHelper.getPositionsOptions(),
            maxOtherInputsLength: Constants.MAX_USER_INPUTS_LENGTH,
            qualificationRedirectUrl: '',
        };
    },
    created() {
        this.stripQualificationUrlParams();
    },
    mounted() {
        this.model = {
            ...this.model,
            ...this.getLocalStorageItem(StorageKeys.QUALIFICATION_DATA)
        }
        this.qualificationRedirectUrl = this.readQualificationRedirectUrl();
    },
    computed: {
        Jobs() {
            return Jobs;
        },
        Tools() {
            return Tools;
        },
        isDisabledToolsNextStep() {
            // не выбран инструмент
            return !this.model.tool
                // выбран инструмент "другое", но не введены данные или больше лимита
                || (this.model.tool === Tools.OTHER && (
                    this.model.otherTool.length < 1 || this.model.otherTool.length > this.maxOtherInputsLength)
                );
        },
        isDisabledJobNextStep() {
            // не выбран инструмент
            return !this.model.job
                // выбран инструмент "другое", но не введены данные или больше лимита
                || (this.model.job === Jobs.OTHER && (
                    this.model.otherJob.length < 1 || this.model.otherJob.length > this.maxOtherInputsLength
                ))
                || (this.model.job === Jobs.COMPANY && (
                    !this.model.jobPosition
                    || this.model.jobCompanySite.length < 1
                    || this.model.jobCompanySite.length > this.maxOtherInputsLength
                ));
        },
        getCountOtherTool() {
            return this.model.otherTool.length;
        },
        getCountOtherJob() {
            return this.model.otherJob.length;
        },
        getPositionLabel() {
            return QualificationsHelper.getPositionLabelById(this.model.jobPosition);
        }
    },
    methods: {
        stepChange(event) {
            this.model.step = event.index + 1;
        },
        stripQualificationUrlParams() {
            if (!window.location.search && !window.location.hash) {
                return;
            }

            history.replaceState(null, '', window.location.pathname);
        },
        onFinish(callbackNext) {
            this.$emitter.emit(Listeners.GLOBAL_PRELOADER_SHOW)
            UserApi.setQualification({
                tool: this.model.tool,
                otherTool: this.model.tool === Tools.OTHER ? this.model.otherTool : null,
                job: this.model.job,
                jobPosition: this.model.job === Jobs.COMPANY ? this.model.jobPosition : null,
                jobCompanySite: this.model.job === Jobs.COMPANY ? this.model.jobCompanySite : null,
                otherJob: this.model.job === Jobs.OTHER ? this.model.otherJob: null,
            })
            .then(() => callbackNext())
            .catch(error => this.alertError(error))
            .finally(() => this.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE));
        },
        onClickStart() {
            window.open(sprintf('/%s/tools', window.locale));
        },
        readQualificationRedirectUrl() {
            const value = localStorage.getItem(StorageKeys.QUALIFICATION_REDIRECT);
            if (!value) {
                return '';
            }

            try {
                const parsed = JSON.parse(value);
                return typeof parsed === 'string' ? parsed : value;
            } catch {
                return value;
            }
        },
        onClickQualificationRedirect() {
            const url = this.readQualificationRedirectUrl() || this.qualificationRedirectUrl;
            nextTick(() => {
                this.safeRedirect(url);
                this.removeLocalStorageItem(StorageKeys.QUALIFICATION_REDIRECT);
            });
        },
        onClickHelp() {
            window.open(sprintf('//help.keys.so', window.locale));
        },
        onClickFAQ() {
            window.open('//help.keys.so/faq');
        },
        onClickRutube() {
            window.open('//rutube.ru/channel/38416987');
        },
        onClickTelegram() {
            window.open('//t.me/keysso_public');
        },
        onOpenDemo() {
            this.$emitter.emit(Listeners.POPUP_DEMO_BLOCK_OPEN, {
                job: this.getPositionLabel,
                site: this.model.jobCompanySite,
            });
        },
    },
    watch: {
        model: {
            handler() {
                // финальный шаг
                if (this.model.step === 3) {
                    this.removeLocalStorageItem(StorageKeys.QUALIFICATION_DATA);
                    return;
                }

                this.setLocalStorageItem(StorageKeys.QUALIFICATION_DATA, {
                    ...this.getLocalStorageItem(StorageKeys.QUALIFICATION_DATA),
                    ...this.model
                });
            },
            deep: true,
        },
    },
    components: {
        Textarea,
        AdaptersDropdown,
        TemplatesLabelCounts,
        Stepper,
        StepperPanel,
        Button,
        RadioButton,
        StepToolsContent,
        InputText,
        StepFinallyReviews,
    }
}
</script>

<style scoped>
.header__logo {
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.header__logo img {
    height: 37px !important;
}
.qualification_page__logout {
    position: absolute;
    right: 0;
    top: 9px;
}
.header__logout a,
.qualification_page__logout a {
    align-items: center;
    display: flex;
    gap: 10px;
    color: #4b5563;
    padding: 10px;
    text-decoration: none;
}
.qualification_page__content {
    background-image: url('/i/pages/qualification/content-bg.webp');
    background-size: cover;
    padding: 60px 200px 0 44px;
}
:deep(.qualification_page__content) .qualification_page__content_main_img {
    width: 80%;
    margin: 0 auto;
    display: block;
    max-width: 100%;
}
.qualification_page__questions {
    padding: 39px 44px 0 200px;
}
.qualification_page__questions h3 {
    margin-bottom: 0;
}
.qualification_page__questions p {
    padding-top: 0;
    color: #6C757D;
}
:deep(.qualification_page__content) .p-stepper-panels {
    background-color: transparent;
}
.qualification_page__secondary_button {
    color: #8F9EAC !important;
    border: 1px solid #CED4DA !important;
}
:deep(.qualification_page__secondary_button) .p-button-icon {
    font-size: 20px;
}
:deep(.qualification_page__secondary_button) .p-button-label {
    font-weight: 500;
}
.qualification_page__finish_header {
    margin-bottom: 128px;
}
@media (max-width: 1600px) {
    .qualification_page__questions {
        padding: 39px 44px 0 100px;
    }
    .qualification_page__content {
        padding: 60px 100px 0 44px;
    }
}
@media (max-width: 1200px) {
    .qualification_page__questions {
        padding: 39px 44px 0 15px;
    }
    .qualification_page__content {
        padding: 60px 15px 0 44px;
    }
}
</style>
